"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createCreateMarketInstruction = void 0;
const beet = __importStar(require("@metaplex-foundation/beet"));
const web3 = __importStar(require("@solana/web3.js"));
const GatingConfig_1 = require("../types/GatingConfig");
const createMarketStruct = new beet.FixableBeetArgsStruct([
    ['instructionDiscriminator', beet.uniformFixedSizeArray(beet.u8, 8)],
    ['treasuryOwnerBump', beet.u8],
    ['name', beet.utf8String],
    ['description', beet.utf8String],
    ['mutable', beet.bool],
    ['price', beet.u64],
    ['piecesInOneWallet', beet.coption(beet.u64)],
    ['startDate', beet.u64],
    ['endDate', beet.coption(beet.u64)],
    ['gatingConfig', beet.coption(GatingConfig_1.gatingConfigBeet)],
], 'CreateMarketInstructionArgs');
const createMarketInstructionDiscriminator = [103, 226, 97, 235, 200, 188, 251, 254];
function createCreateMarketInstruction(accounts, args) {
    const { market, store, sellingResourceOwner, sellingResource, mint, treasuryHolder, owner, collectionMint, } = accounts;
    const [data] = createMarketStruct.serialize({
        instructionDiscriminator: createMarketInstructionDiscriminator,
        ...args,
    });
    const keys = [
        {
            pubkey: market,
            isWritable: true,
            isSigner: true,
        },
        {
            pubkey: store,
            isWritable: false,
            isSigner: false,
        },
        {
            pubkey: sellingResourceOwner,
            isWritable: true,
            isSigner: true,
        },
        {
            pubkey: sellingResource,
            isWritable: true,
            isSigner: false,
        },
        {
            pubkey: mint,
            isWritable: false,
            isSigner: false,
        },
        {
            pubkey: treasuryHolder,
            isWritable: true,
            isSigner: false,
        },
        {
            pubkey: owner,
            isWritable: false,
            isSigner: false,
        },
        {
            pubkey: web3.SystemProgram.programId,
            isWritable: false,
            isSigner: false,
        },
    ];
    if (collectionMint) {
        keys.push({
            pubkey: collectionMint,
            isWritable: false,
            isSigner: false,
        });
    }
    const ix = new web3.TransactionInstruction({
        programId: new web3.PublicKey('SaLeTjyUa5wXHnGuewUSyJ5JWZaHwz3TxqUntCE9czo'),
        keys,
        data,
    });
    return ix;
}
exports.createCreateMarketInstruction = createCreateMarketInstruction;
//# sourceMappingURL=createMarket.js.map